import { render, staticRenderFns } from "./VSubOrderAddress.vue?vue&type=template&id=13e36352&scoped=true"
import script from "./VSubOrderAddress.vue?vue&type=script&lang=ts"
export * from "./VSubOrderAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e36352",
  null
  
)

export default component.exports